import { useGQLQueryMultipleRecordsWithClient } from '../../hooks/useGQLQueryWithClient';
import { GraphQLClient } from 'graphql-hooks';
import "./ArticlesWithoutStoriesList.css"

import { useState } from 'react';

/*
Want to list every Articles without story

To list every articles, I want to go trough this query:

query ArticleRecord {
  allArticles(first: 10, skip: 1) {
    title
    id
  }
}

After that, I have to query every Stories using this:



I have to make the diff between the two lists

*/

function getArticles({ first, skip }: { first: number, skip: number }) {
  return `query ArticleRecord {
    allArticles(first: ${first}, skip: ${skip}) {
      title
      id
    }
  }
  `;
}

type ArticleData = {
  title: string;
  id: string;
};



function getStories({first, skip} : {first : number, skip : number}) {
  return `query StoryRecord {
    allStories(first: ${first}, skip: ${skip}) {
      originalArticle { id }
    }
  }`;
}

type StoryData = {
  originalArticle : {
    id : string;
  }
};

const client = new GraphQLClient({
  url: "https://graphql.datocms.com/",
  headers: {
    "Authorization": `Bearer c2637bf4c3ca322961249cf1b65310`, // Todo use user token
    "X-Include-Drafts": "true",
  }
});

function UnreferencedArticle({ id, title }: ArticleData) {
  return (
    <div className="unreferencedArticle">
      <a
        href={`https://cycle-tracker-backend.admin.datocms.com/editor/item_types/ED5FmxxCRSyH_nJ0wh5zLQ/items/${id}`}
      >
        {title}
      </a>
    </div>
  );
}

export default function ArticlesWithoutStoriesList() {
  const { loading: loadingArticles, error: errorArticles, data: rawArticles } = useGQLQueryMultipleRecordsWithClient(client, getArticles, 100);
  const { loading: loadingStories, error: errorStories, data: rawStories } = useGQLQueryMultipleRecordsWithClient(client, getStories, 100);

  const [isOpen, setIsOpen] = useState(false);

  const articles = rawArticles as ArticleData[];
  const stories = rawStories as StoryData[];

  if (errorArticles || errorStories) return <div>Data loading error</div>;
  if (loadingArticles || loadingStories) return <div>Loading data...</div>;

  const referencedArticleIds = new Set(stories.map(story => story.originalArticle.id));
  const unreferencedArticles = articles.filter(article => !referencedArticleIds.has(article.id));

  return (
    <>
      <h1>Articles without stories</h1>
      <div className="unreferencedArticleText">
        Total number of articles: {articles.length}<br />
        Articles without stories: {unreferencedArticles.length}
      </div>

      <div
        className="unreferencedArticleToggle"
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? 'Hide articles without story ▲' : 'Show articles without story ▼'}
      </div>

      {isOpen && (
        <>
          <div className="unreferencedArticleHeader">The following articles have no story:</div>
          {unreferencedArticles.map(a => (
            <UnreferencedArticle key={a.id} {...a} />
          ))}
        </>
      )}
    </>
  );
}
